export function isBandScale(scale) {
  return scale.bandwidth !== undefined;
}